(() => {
  if (customElements.get('liene-video-gallery')) return;
  const storagePrefix = 'liene:video-like:v1:';
  const visitorKey = 'liene:video-like:visitor';
  const memory = new Map();
  let sessionVisitor;
  const validRecord = value => value && typeof value.liked === 'boolean' && Number.isSafeInteger(value.count) && value.count >= 0;
  customElements.define('liene-video-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.tabResize?.disconnect(); this.abort = new AbortController(); this.requests = new Set();
      const options = { signal: this.abort.signal };
      this.player = this.querySelector('liene-inspiration');
      this.cards = [...this.querySelectorAll('.lii__card')];
      this.tabs = [...this.querySelectorAll('.lig__tab')];
      this.more = this.querySelector('.lig__more');
      this.mobile = matchMedia('(max-width: 749px)');
      this.category = 'all'; this.expanded = false; this.mobileExtra = 0;
      this.tabs.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.category; this.expanded = false; this.mobileExtra = 0; this.filter();
        this.centerTab(button);
      }, options));
      this.querySelector('.lig__nav').addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const index = this.tabs.indexOf(event.target); if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus(); this.tabs[next].click();
      }, options);
      this.more.addEventListener('click', () => {
        const next = this.cards.find(card => card.hidden && this.matchesCategory(card));
        const collapsing = this.expanded;
        if (collapsing) { this.expanded = false; this.mobileExtra = 0; }
        else if (this.mobile.matches) {
          this.mobileExtra += 6;
          this.expanded = this.limit() + this.mobileExtra >= this.cards.filter(card => this.matchesCategory(card)).length;
        } else this.expanded = true;
        this.filter();
        if (collapsing) {
          this.more.focus({ preventScroll: true });
          this.more.scrollIntoView({ block: 'nearest' });
          return;
        }
        next?.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
      }, options);
      this.mobile.addEventListener('change', () => { this.expanded = false; this.mobileExtra = 0; this.filter(); this.centerTab(this.tabs.find(button => button.dataset.category === this.category), false); }, options);
      this.tabResize = new ResizeObserver(() => this.centerTab(this.tabs.find(button => button.dataset.category === this.category), false));
      this.tabResize.observe(this.querySelector('.lig__nav'));
      this.addEventListener('shopify:block:select', event => {
  const tab = event.target.closest('.lig__tab');

  if (tab && this.contains(tab)) {
    this.category = tab.dataset.category;
    this.expanded = false;
    this.mobileExtra = 0;
    this.filter();
    this.centerTab(tab, false);
    return;
  }

  const card = event.target.closest('.lii__card');
  if (!card) return;

  this.category = 'all';
  this.expanded = true;
  this.mobileExtra = 0;
  this.filter();
  card.scrollIntoView({ block: 'nearest' });
}, options);
      this.filter();
      this.remote = Boolean(this.dataset.likesEndpoint.trim());
      this.cards.forEach(card => {
        const button = card.querySelector('.lig__like');
        const initial = Number(card.dataset.baseLikes);
        card.baseLikes = Number.isSafeInteger(initial) && initial >= 0 ? initial : 0;
        if (this.remote) button.disabled = true;
        else this.localState(card);
        button.addEventListener('click', () => this.toggleLike(card), options);
      });
      window.addEventListener('storage', event => {
        if (!this.remote && (!event.key || event.key.startsWith(storagePrefix))) this.cards.forEach(card => this.localState(card));
      }, options);
      window.addEventListener('liene:video-like', event => {
        if (this.remote) return;
        this.cards.filter(card => card.dataset.likeKey === event.detail.key).forEach(card => this.paintLike(card, event.detail.liked, card.baseLikes + Number(event.detail.liked)));
      }, options);
      if (this.remote) this.loadLikes();
    }
    matchesCategory(card) {
      return this.category === 'all' || [card.dataset.category, card.dataset.category2, card.dataset.category3].includes(this.category);
    }
    centerTab(button, animate = true) {
      const nav = this.querySelector('.lig__nav');
      if (!this.mobile.matches) { nav.style.paddingLeft = ''; nav.style.paddingRight = ''; return; }
      if (!button) return;
      // Keep the original left edge; only the third and later tabs center.
      nav.style.paddingLeft = '';
      nav.style.paddingRight = `${Math.max(5, (nav.clientWidth - this.tabs.at(-1).offsetWidth) / 2)}px`;
      const navRect = nav.getBoundingClientRect(), tabRect = button.getBoundingClientRect();
      const left = this.tabs.indexOf(button) < 2 ? 0 : nav.scrollLeft + tabRect.left + tabRect.width / 2 - navRect.left - nav.clientWidth / 2;
      nav.scrollTo({ left, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    limit() {
      const positive = (value, fallback) => Math.max(1, Math.min(50, Number.parseInt(value, 10) || fallback));
      return this.mobile.matches ? positive(this.dataset.mobileCount, 6) : positive(this.dataset.columns, 3) * positive(this.dataset.rows, 3);
    }
    filter() {
      const matching = this.cards.filter(card => this.matchesCategory(card));
      const shown = new Set(this.expanded ? matching : matching.slice(0, this.limit() + (this.mobile.matches ? this.mobileExtra : 0)));
      this.cards.forEach(card => {
        card.hidden = !shown.has(card);
        if (card.hidden) this.player.pause?.(card);
      });
      this.tabs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      this.more.hidden = matching.length <= this.limit();
      this.more.querySelector('span').textContent = this.expanded ? 'View Less' : 'View More';
      this.more.setAttribute('aria-expanded', String(this.expanded));
      this.querySelector('.lig__empty').hidden = matching.length > 0;
    }
    notice(message) {
      const node = this.querySelector('.lig__notice'); node.textContent = message; node.hidden = !message;
    }
    localState(card) {
      const key = storagePrefix + card.dataset.likeKey;
      let liked = memory.get(key) || false;
      try { liked = localStorage.getItem(key) === 'true'; } catch (_) { /* Session fallback if storage is unavailable. */ }
      this.paintLike(card, liked, card.baseLikes + Number(liked));
    }
    paintLike(card, liked, count) {
      card.liked = liked;
      const button = card.querySelector('.lig__like');
      button.setAttribute('aria-pressed', String(liked));
      button.setAttribute('aria-label', `${liked ? 'Unlike' : 'Like'} ${card.dataset.title}`);
      button.title = this.remote ? 'Community likes' : 'Saved on this browser';
      button.querySelector('.lig__like-count').textContent = String(count);
    }
    endpoint() {
      const path = this.dataset.likesEndpoint.trim();
      if (!path.startsWith('/apps/')) throw new Error('App proxy required');
      const url = new URL(path, location.origin);
      if (url.origin !== location.origin || url.search || url.hash) throw new Error('Invalid proxy path');
      return url;
    }
    visitor() {
      try {
        const saved = localStorage.getItem(visitorKey);
        if (saved && /^[a-zA-Z0-9-]{16,64}$/.test(saved)) return saved;
      } catch (_) { /* Use a session ID when storage is unavailable. */ }
      sessionVisitor ||= crypto.randomUUID();
      try { localStorage.setItem(visitorKey, sessionVisitor); } catch (_) { /* The server still deduplicates this session. */ }
      return sessionVisitor;
    }
    async request(url, options = {}) {
      const controller = new AbortController(); this.requests.add(controller);
      const timer = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url, { ...options, credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Likes unavailable');
        return await response.json();
      } finally { clearTimeout(timer); this.requests.delete(controller); }
    }
    async loadLikes() {
      try {
        const url = this.endpoint();
        url.searchParams.set('ids', JSON.stringify([...new Set(this.cards.map(card => card.dataset.likeKey))]));
        url.searchParams.set('visitor', this.visitor());
        const data = await this.request(url);
        if (!this.isConnected) return;
        if (!data || !data.videos || this.cards.some(card => !validRecord(data.videos[card.dataset.likeKey]))) throw new Error('Invalid counts');
        this.cards.forEach(card => {
          const record = data.videos[card.dataset.likeKey]; this.paintLike(card, record.liked, record.count);
          card.querySelector('.lig__like').disabled = false;
        });
      } catch (_) { if (this.isConnected) this.notice('Likes are temporarily unavailable. Please refresh to try again.'); }
    }
    async toggleLike(card) {
      const liked = !card.liked, key = card.dataset.likeKey, button = card.querySelector('.lig__like');
      if (!this.remote) {
        memory.set(storagePrefix + key, liked);
        try { localStorage.setItem(storagePrefix + key, String(liked)); this.notice(''); }
        catch (_) { this.notice('Your like is saved for this visit only because browser storage is unavailable.'); }
        window.dispatchEvent(new CustomEvent('liene:video-like', { detail: { key, liked } }));
        return;
      }
      if (button.disabled) return;
      button.disabled = true; button.setAttribute('aria-busy', 'true');
      try {
        const data = await this.request(this.endpoint(), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ videoId: key, visitor: this.visitor(), liked })
        });
        if (!validRecord(data) || data.videoId !== key) throw new Error('Invalid response');
        if (this.isConnected) {
          this.cards.filter(item => item.dataset.likeKey === key).forEach(item => this.paintLike(item, data.liked, data.count));
          this.notice('');
        }
      } catch (_) { if (this.isConnected) this.notice('Your like could not be saved. Please try again.'); }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.tabResize?.disconnect(); this.requests?.forEach(controller => controller.abort());
    }
  });
})();
